module.exports = __webpack_public_path__ + "img/people-tab4.cd23fabc.png";